'use strict';

const { h } = require('preact');
const { hydrate } = require('@grpn/hydration');

const OfferRedemptionText = require('../../shared/views/offer/offer-redemption-text');
const { redemptionHandler } = require('../../support/redemption-handler');
const { publish } = require('../../support/event-observer');
const { getReferralSource } = require('../../support/redemption-helper');

function CouponButton({ coupon, className = '' }, context) {
  const {
    directRedemption,
    referralSource,
    showDisruptor,
    merchantName = '',
  } = context;

  const { offerId, offerType, isPremiumOffer } = coupon;

  const clickRedemptionHandler = () => {
    const redemptionData = {
      offerId,
      referralSource: getReferralSource({
        referralSource,
        offerId,
        directRedemption,
      }),
      merchantName,
      offerType,
      isPremiumOffer,
    };

    if (showDisruptor) {
      publish('@redemption', {
        ...redemptionData,
        type: 'DISRUPT',
      });
    } else {
      redemptionHandler(redemptionData).then(data =>
        publish('@redemption', data)
      );
    }
  };

  const keyUpRedemptionHandler = ev => {
    if (ev.keyCode === 13) {
      clickRedemptionHandler();
    }
  };

  return h(
    'a',
    {
      className,
      tabindex: 0,
      onClick: clickRedemptionHandler,
      onKeyUp: keyUpRedemptionHandler,
      'data-bhc': `coupon:${offerId}`,
      'data-bhd': JSON.stringify({ type: offerType }),
    },
    !(className && className.includes('coupon-background')) &&
      OfferRedemptionText({
        type: offerType,
      })
  );
}

module.exports = hydrate('CouponButton', CouponButton);
